export default {
  total: state => state.total,
  items: state => state.items,
  success: state => state.success,
  successServer: state => state.successServer,
  state: _state => _state.cartState
};